import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
interface ProgressBarProps {
  current: number;
  total: number;
  onBack: () => void;
  onNext: () => void;
}
export function ProgressBar({
  current,
  total,
  onBack,
  onNext
}: ProgressBarProps) {
  const progress = (current + 1) / total * 100;
  return <div className="absolute top-0 left-0 w-full z-50" data-id="element-1035" data-mp="23l22mtpnfe4c">
      <div className="h-1 bg-navy-700 w-full" data-id="element-1036" data-mp="28lq1u2o1719n">
        <motion.div className="h-full bg-teal-400" initial={{
        width: 0
      }} animate={{
        width: `${progress}%`
      }} transition={{
        duration: 0.5,
        ease: 'easeInOut'
      }} data-id="element-1037" data-mp="2co376pyv8x5w" />
      </div>
      <div className="flex items-center justify-between px-6 pt-3 pl-44" data-id="element-1038" data-mp="2rczegkt3m65g">
        <button onClick={onBack} disabled={current === 0} className="flex items-center gap-1 text-sm font-medium text-white/50 hover:text-white transition-colors disabled:opacity-20 disabled:cursor-not-allowed" data-id="element-1039" data-mp="2rawcr3il2okw">
          <ChevronLeftIcon className="w-4 h-4" data-id="element-1040" data-mp="1xzl1cmdh24b8" />
          Back
        </button>
        <span className="text-xs font-medium text-white/40 tracking-widest" data-id="element-1041" data-mp="1t0hucwdxlo0m">
          {current + 1} / {total}
        </span>
        <button onClick={onNext} disabled={current === total - 1} aria-label="Next slide" className="flex items-center gap-1.5 text-sm font-bold px-5 py-2.5 rounded-full bg-[#6C2BD9] text-white shadow-lg shadow-[#6C2BD9]/30 hover:bg-[#5A23B8] hover:shadow-xl hover:shadow-[#6C2BD9]/40 hover:-translate-y-0.5 active:translate-y-0 transition-all disabled:opacity-30 disabled:cursor-not-allowed disabled:hover:translate-y-0 disabled:hover:bg-[#6C2BD9]" style={{
        color: '#ffffff'
      }} data-id="element-1042" data-mp="1p07rhslfrdpz">
          Next
          <ChevronRightIcon className="w-4 h-4" style={{
          color: '#ffffff'
        }} data-id="element-1043" data-mp="2zoohx44t8uik" />
        </button>
      </div>
    </div>;
}